export enum ClassActivityCategory {
    VOCAB_TRAINING = "VOCAB_TRAINING",
    TEST = "TEST",
}

export const selectedCardStyles: Record<ClassActivityCategory, string> = {
    [ClassActivityCategory.TEST]: "border-2 border-p6-orange bg-p6-orange-light-pastel",
    [ClassActivityCategory.VOCAB_TRAINING]: "border-2 border-forest-green-800 bg-forest-green-pastel",
};

export const checkboxCheckedStyles: Record<ClassActivityCategory, string> = {
    [ClassActivityCategory.TEST]: "border-p6-orange bg-p6-orange",
    [ClassActivityCategory.VOCAB_TRAINING]: "border-forest-green-800 bg-forest-green-800",
};

export const classActivityColors = {
    [ClassActivityCategory.VOCAB_TRAINING]: {
        border: "border-forest-green-800",
        cardBorder: "border-forest-green-800/40",
        text: "text-forest-green-800",
        buttonBorder: "border-forest-green-800",
        buttonText: "text-forest-green-800",
        buttonHover: "hover:bg-forest-green-800/10",
    },
    [ClassActivityCategory.TEST]: {
        border: "border-p6-orange",
        cardBorder: "border-p6-orange/40",
        text: "text-p6-orange",
        buttonBorder: "border-p6-orange",
        buttonText: "text-p6-orange",
        buttonHover: "hover:bg-p6-orange-light-pastel",
    },
};
